import SectionLayout from './SectionLayout';

export default SectionLayout;
